<template>
  <el-container class="section-cnr" direction="vertical">
    <el-container>
      <el-aside class="y-sub-menu-ctr">
        <y-sub-menu ref="subMenu" />
      </el-aside>
      <el-container direction="vertical">
        <div v-show="!isNewDesignEnabled()" class="y-sub-header-ctr">
          <el-row align="middle">
            <el-col :span="10" class="y-sub-header-heading">
              <el-row align="middle">
                <el-col class="caption-text">{{ headerSubText }}</el-col>
              </el-row>
            </el-col>
            <el-col :span="14">
              <div class="y-sub-header-button-ctr">
                <el-button type="text" @click="backToSubbrandList">
                  <i class="el-icon-back back-icon"></i> Back to Sub-brand List
                </el-button>
                <!-- <el-button @click="previewSubbrand" :loading="previewLoding">{{previewBtnText}}</el-button> -->
                <el-button type="primary" @click="saveBrandData">Save</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row
            align="middle"
            type="flex"
            class="finapp-ctr"
            :class="isNewDesignEnabled() ? 'newDesign':''"
          >
            <el-col>
              <y-finapp-prview />
            </el-col>
          </el-row>
        </div>
      </el-container>
    </el-container>
    <el-dialog
      :visible.sync="saveConfirmPopup"
      :show-close="showCloseForConfirmPopup"
      top="45vh"
      custom-class="y-confirm-popup"
      width="260px"
    >
      <span>Save changes before you go?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="discardChanges">Discard</el-button>
        <el-button type="primary" @click="saveAndRouteToList">Save</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showPopupBlockerMsg"
      custom-class="y-message-popup no-title-bar"
      :show-close="showCloseForMsgPopup"
      width="400px"
    >
      <span>Your popup blocker is preventing you from proceeding. To continue, please disable your popup blocker for this site.</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopupBlockerMsg = false" type="primary">Got it</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import _ from 'underscore'
import SubMenu from './subMenu.vue'
import FinappPrviewLayout from './finappPreview.vue'
import serviceRegistery from '../../mixins/serviceRegistery'
import { custToolHelper } from '../../mixins/custToolHelper'
import { helpers } from '../../mixins/helpers'

export default {
  components: {
    'y-sub-menu': SubMenu,
    'y-finapp-prview': FinappPrviewLayout
  },
  props: {},
  inject: ['$validator'],
  mixins: [custToolHelper, serviceRegistery, helpers],
  data() {
    return {
      viewPortIcon: 'desktop_mac',
      toastMessageTimeout: 2000,
      fontFileName: '',
      fontFile: [],
      fontList: [],
      labelName: '',
      labelDesc: '',
      saveConfirmPopup: false,
      showCloseForConfirmPopup: false,
      previewLoding: false,
      previewBtnText: 'Preview',
      showPopupBlockerMsg: false,
      showCloseForMsgPopup: false
    }
  },
  created() {
    console.log('CT Layout loaded')
    this.$router.push('/customization/CTDataloader')
    this.$nextTick(function() {
      this.$store.state.custAppStore.finappSrc = this.$finappIframeUrl
    })
  },
  computed: {
    showFontUploadDialog: {
      set() {
        this.$store.state.custAppStore.showFontUploadDialog
      },
      get() {
        return this.$store.state.custAppStore.showFontUploadDialog
      }
    },
    showCreateLabelDialog: {
      set() {
        this.$store.state.custAppStore.showCreateLabelDialog
      },
      get() {
        return this.$store.state.custAppStore.showCreateLabelDialog
      }
    },
    headerSubText() {
      return this.$store.state.appStore.selectedSubbrandInfo.name
    },
    finappSrc() {
      return this.$store.state.custAppStore.finappSrc
    },
    iframeWidth() {
      return this.$store.state.custAppStore.iframeWidth
    },
    mediaClass() {
      return this.$store.state.custAppStore.mediaClass
    },
    toastMessage() {
      return this.$store.state.custAppStore.toastMessage
    },
    dataChanged() {
      return this.$store.state.custAppStore.dataChanged
    }
  },
  methods: {
    isNewDesignEnabled() {
      return this.$enableNewDesign
    },
    backToSubbrandList() {
      let brandJsonData = this.getBrandJsonData()
      if (brandJsonData && brandJsonData.dataChanged) {
        this.saveConfirmPopup = true
      } else {
        this.$router.push('/dataloader')
      }
    },
    discardChanges() {
      this.saveConfirmPopup = false
      this.$router.push('/dataloader')
    },
    saveAndRouteToList() {
      this.saveConfirmPopup = false
      this.saveBrandData(false, true)
    },

    previewSubbrand() {
      // Save brand data and Publish brand data
      this.saveBrandData(true)
    },
    getBrandJsonData() {
      // PARAM CHANGES
      var brandJsonData = {
        brandJson: {},
        dataChanged: false
      }

      this.generateCobrandJsonParam(
        this.$store.state.paramStore.dbParams,
        this.$store.state.paramStore.loadedParams,
        brandJsonData
      )

      console.log('PARAM CHANGED-->', brandJsonData)

      // END - PARAM CHANGES

      // CSS CHANGES

      this.generateCobrandJsonCss(
        this.$store.state.cssStore.dbCss,
        this.$store.state.cssStore.loadedCss,
        brandJsonData
      )

      // END - CSS CHANGES

      // LOCALE CHANGES
      this.generateCobrandJsonLocale(
        this.$store.state.localeStore.dbStrings,
        this.$store.state.localeStore.loadedStrings,
        brandJsonData
      )

      // END - LOCALE CHANGES

      return brandJsonData
    },
    saveBrandData(isPreview, isBackToSubbrand) {
      var self = this
      Promise.all([
        this.$refs.subMenu.$refs.featuresTab.validateParamData(),
        this.$refs.subMenu.$refs.textTab.validateTextData()
      ]).then(result => {
        console.log('promise all-->', result)
        if (!result[0]) {
          this.$message.closeAll();
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'error',
            message:
              '<div class="el-message__content-ctr"><span class="icon-ctr">&nbsp;</span><span class="message-ctr">Please correct the errors in features tab.</span></div>',
            duration: 4000
          })

          return false
        } else if (!result[1]) {
          this.$message.closeAll();
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'error',
            message:
              '<div class="el-message__content-ctr"><span class="icon-ctr">&nbsp;</span><span class="message-ctr">Please correct the errors in text tab.</span></div>',
            duration: 4000
          })
          return false
        }
        if (result[0] && result[1]) {
          let brandJsonData = this.getBrandJsonData()

          console.log('Brands OBJ---->', brandJsonData.brandJson)
          if (brandJsonData && brandJsonData.dataChanged) {
            let _id = this.$store.state.appStore.selectedSubbrandInfo._id

            var selectedInfo = this.$store.state.appStore.selectedSubbrandInfo

            var config = {}

            if (
              brandJsonData.brandJson['param.default.tnc.global'] !== undefined
            ) {
              brandJsonData.brandJson['pfile.default.tnc.en_US'] =
                brandJsonData.brandJson['param.default.tnc.global']
            }
            
            if (
              brandJsonData.brandJson['param.default.popularSites.global'] !=
              undefined
            ) {
                var popularSites = []
                brandJsonData.brandJson['param.default.popularSites.global'].forEach((item)=>{
                    popularSites.push(item.id)
                })

              config[
                'productConfig.aggregation.features.popularSites.value'
              ] = popularSites.join(',')

              config[
                'productConfig.verification.features.popularSites.value'
              ] = popularSites.join(',')
            }

            console.log('BRAND JSON----> ', brandJsonData.brandJson)
            let reqObj = {
              id: _id,
              jsonData: JSON.stringify({
                brand: brandJsonData.brandJson,
                config: config
              })
            }

            serviceRegistery
              .makeCall({
                url: this.$hostname + 'services/subbrand/update',
                method: 'POST',
                data: reqObj
              })
              // get data
              .then(() => {
                console.log('Cobrand branding data Saved')
                this.$store.state.paramStore.dbParams = JSON.parse(
                  JSON.stringify(this.$store.state.paramStore.loadedParams)
                )
                this.$store.state.cssStore.dbCss = JSON.parse(
                  JSON.stringify(this.$store.state.cssStore.loadedCss)
                )
                this.$store.state.localeStore.dbStrings = JSON.parse(
                  JSON.stringify(this.$store.state.localeStore.loadedStrings)
                )
                this.$store.state.custAppStore.dataChanged = false
                if (isPreview === true) {
                  this.previewPublish()
                } else if (isBackToSubbrand === true) {
                  this.$router.push('/dataloader')
                } else {
                  this.$message.closeAll();
                  this.$message({
                    dangerouslyUseHTMLString: true,
                    type: 'success',
                    message:
                      '<div class="el-message__content-ctr"><span class="icon-ctr">&nbsp;</span><span class="message-ctr">Changes have been saved successfully.</span></div>',
                    duration: 4000
                  })
                }
              })
              .catch(error => {
                this.showToastMessage(
                  'Sorry, a technical error has occurred! Please try again later.'
                )
              })
          } else {
            if (isPreview === true) {
              this.previewPublish()
            }
          }
        }
      })
    },
    previewPublish() {
      // Add Loading Indicator
      this.previewLoding = true
      this.previewBtnText = 'loading preview'

      let _id = this.$store.state.appStore.selectedSubbrandInfo._id
      let subInfo = this.$store.state.appStore.selectedSubbrandInfo
      let finappId = '10003600'
      if (subInfo.config.appConfig) {
        if (subInfo.config.appConfig.pfm.enabled === true) {
          finappId = '10003700'
        } else if (subInfo.config.appConfig.fl.enabled === true) {
          finappId = '10003600'
        }
      }
      let reqObj = {
        id: _id,
        finappId: finappId
      }
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/brand/publish',
          method: 'POST',
          data: reqObj
        })
        // get data
        .then(response => {
          console.log('Brand data Preview Published', response.data)
          if (response.data && response.data.url) {
            var self = this
            setTimeout(function() {
              self.openPreviewPage(response.data.url)
            }, 40000)
          }
        })
        .catch(error => {
          this.showToastMessage(
            'Sorry, a technical error has occurred! Please try again later.'
          )
          this.previewLoding = false
          this.previewBtnText = 'Preview'
        })
    },
    openPreviewPage(url) {
      this.previewLoding = false
      this.previewBtnText = 'Preview'
      let preview_popup = window.open(url, 'preview')
      console.log('popup', typeof preview_popup)
      if (!preview_popup) {
        this.showPopupBlockerMsg = true
      }
    }
  }
}
</script>

<style>
.section-cnr {
  height: calc(100vh - 144px);
}
.y-sub-header-ctr {
  height: 72px;
  min-height: 72px;
  line-height: 72px;
  padding-right: 24px;
  border-bottom: 1px solid #dedede;
}
.y-sub-header-ctr.newDesign {
  border-bottom-width: 0;
}
.y-sub-header-heading {
  text-align: center;
  font-size: 18px;
  color: #383838;
  margin-top: 24px;
}
.y-sub-header-heading .heading-text {
  height: 20px;
  line-height: 20px;
}
.y-sub-header-heading .caption-text {
  height: 24px;
  line-height: 24px;
  padding-left: 14px;
  font-size: 20px;
  text-align: left;
  color: #747474;
}
.y-sub-header-button-ctr {
  text-align: right;
}
.y-sub-menu-ctr {
  min-width: 380px;
}
.back-icon {
  font-size: 18px;
  vertical-align: text-top !important;
}
.finapp-ctr {
  height: calc(100vh - 144px);
  justify-content: center;
  flex-direction: column;
  padding: 10px 10px 8px;
  border-left: 1px solid #dedede;
}
.finapp-ctr.newDesign {
  border-left-width: 0;
}
.iframe-ctr {
  height: 100%;
  display: block;
  margin: 0 auto;
}
.y-confirm-popup.el-dialog {
  border-radius: 6px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
  min-width: 270px;
}
.y-confirm-popup .el-dialog__header {
  display: none;
}
.y-confirm-popup .el-dialog__body {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  padding: 24px 20px 6px 20px;
}
.y-confirm-popup .el-dialog__footer {
  text-align: center;
  padding-bottom: 30px;
}
</style>
